/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Co as Co,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SinSecciones as SinSecciones,
  rec_jt as jt,
  rec_rt as rt,
  rec_uo as uo,
  rec_wo as wo,
} from "../../runtime/index.jsx";
export function AccesoDenegado() {
  let e = (0, ReactCompiler.c)(11),
    { pathname: t } = rt(),
    n,
    r;
  e[0] === t
    ? ((n = e[1]), (r = e[2]))
    : ((n = wo()),
      (r = n != null && (n === t || !Co(n))),
      (e[0] = t),
      (e[1] = n),
      (e[2] = r));
  let i = r,
    a,
    o;
  if (
    (e[3] !== n || e[4] !== t || e[5] !== i
      ? ((a = () => {
          i &&
            uo({
              tipo: `RedireccionEnBucle`,
              mensaje: `${t} → ${n}`,
              traza: null,
            });
        }),
        (o = [i, t, n]),
        (e[3] = n),
        (e[4] = t),
        (e[5] = i),
        (e[6] = a),
        (e[7] = o))
      : ((a = e[6]), (o = e[7])),
    (0, React.useEffect)(a, o),
    n == null || i)
  ) {
    let t;
    return (
      e[8] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <SinSecciones />), (e[8] = t))
        : (t = e[8]),
      t
    );
  }
  let s;
  return (
    e[9] === n
      ? (s = e[10])
      : ((s = (0, JSXRuntime.jsx)(jt, {
          to: n,
          replace: !0,
        })),
        (e[9] = n),
        (e[10] = s)),
    s
  );
}
